import { schema } from 'normalizr'

export default [new schema.Entity('providersBuilders', {}, { idAttribute: 'service_provider_id' })]
